/**
 * Note: this also includes element tracking. They are similar enough to include in the same tracking function.
 */

import { ELEMENT_CLICKED, LINK_CLICKED } from '../redux/tracking';
import get from 'lodash/get';
import type {
  ClickTrackingState,
  EventTracking,
  ElementClickedAction,
  LinkClickHistory,
  LinkClickedAction,
  LinkTrackingState,
} from '../types';

import type { TrackingActionWithId } from '../types/tracking';

export const pbr_link_clicked = 'pbr_link_clicked';
export const pbr_element_clicked = 'pbr_element_clicked';

function elementClicked(
  action: ElementClickedAction,
  state: ClickTrackingState,
): TrackingActionWithId {
  const id = get(action, 'payload.id');
  const additionalTrackingProps = get(
    action,
    'payload.additionalTrackingProps',
  );

  return { id, ...additionalTrackingProps };
}

function linkClicked(
  action: LinkClickedAction,
  state: LinkTrackingState,
): LinkClickHistory {
  const href = get(action, 'payload.link.href');
  const description = get(action, 'payload.link.description');
  const id = get(action, 'payload.link.id');
  const additionalTrackingProps = get(
    action,
    'payload.link.additionalTrackingProps',
  );

  return { href, description, id, ...additionalTrackingProps };
}

// Make sure you cast this before you export it in your duckling;
// we have to verify type BEFORE we leave the execution context of this module.
//
// The best way to do this is actually to create the object
// and do each assignment individually... for now.

const tracking: EventTracking = {};

tracking[LINK_CLICKED] = linkClicked;
tracking[ELEMENT_CLICKED] = elementClicked;

export default tracking;
